<div class="gather-viewer" #container>
  @if (plotRect(); as rect) {
    <div
      class="plot-area"
      [class.zoomed]="isZoomed()"
      [style.left.px]="rect.left"
      [style.top.px]="rect.top"
      [style.width.px]="rect.width"
      [style.height.px]="rect.height"
      (mousedown)="onPointerDown($event)"
      (mousemove)="onPointerMove($event)"
      (mouseup)="onPointerUp($event)"
      (mouseleave)="onPointerLeave()"
    >
      @if (imageSrc(); as src) {
        @if (imageBox(); as box) {
          <img
            [src]="src"
            alt="Shot gather"
            draggable="false"
            [style.left.px]="box.left"
            [style.top.px]="box.top"
            [style.width.px]="box.width"
            [style.height.px]="box.height"
          />
        }
      } @else if (!loading()) {
        <div class="plot-placeholder">No gather loaded</div>
      }

      @if (selectionRect(); as sel) {
        <div
          class="zoom-rect"
          [style.left.px]="sel.left"
          [style.top.px]="sel.top"
          [style.width.px]="sel.width"
          [style.height.px]="sel.height"
        ></div>
      }
    </div>
  }

  <!-- D3 axes + selected-trace marker are drawn into this svg -->
  <svg #axes class="axes-svg"></svg>

  @if (isZoomed()) {
    <button
      class="zoom-reset"
      nz-button
      nzSize="small"
      nz-tooltip
      nzTooltipTitle="Reset zoom"
      (click)="resetZoom()"
    >
      <span nz-icon nzType="fullscreen-exit"></span>
      Reset zoom
    </button>
  }

  @if (meta(); as m) {
    <div class="meta-caption">
      {{ m.n_traces }} traces &middot; clip {{ formatAmp(m.clip_value) }}
      &middot; vmin {{ formatAmp(m.vmin) }} &middot; vmax
      {{ formatAmp(m.vmax) }}
    </div>
  }

  @if (loading()) {
    <div class="loading-overlay">
      <nz-spin nzSize="large"></nz-spin>
    </div>
  }
</div>
